const RouteTitleConfig = {
    Book: [
        // {
        //     url: '/book',
        //     key: 'index',
        //     label: '전체 서재'
        // },
        {
            url: '/book/mine?range=READING',
            key: 'mine',
            label: '내 서재'
        },
        {
            url: '/book/statistics',
            key: 'statistics',
            label: '통계'
        },
        {
            url: '/book/calendar',
            key: 'calendar',
            label: '독서 달력'
        },
    ],

    Library: [
        {
            url: '/library',
            key: 'library',
            label: '도서관 찾기',
        },
        {
            url: '/library/membership',
            key: 'membership',
            label: '회원증',
        },
    ],

    Community: [
        {
            url: '/community/book-recommendations',
            key: 'recommendations',
            label: '책 추천'
        },
        {
            url: '/community/popular-books',
            key: 'popular',
            label: '베스트셀러'
        },
        {
            url: '/community/tips?range=all',
            key: 'tips',
            label: '꿀팁'
        },
    ],

    Add: [
        {
            url: '/add/book',
            key: 'BOOK',
            label: '책 추가하기'
        },
        {
            url: '/add/membership',
            key: 'MEMBERSHIP',
            label: '회원증 추가하기'
        }
    ],

    Settings: [
        {
            url: '/settings/personal-infos',
            key: 'PERSONAL',
            label: '계정'
        },
        {
            url: '/settings/profiles',
            key: 'PROFILE',
            label: '내 프로필'
        },
        {
            url: '/settings/book-shelf',
            key: 'BOOK_SHELF',
            label: '내 서재'
        },
        {
            url: '/settings/search',
            key: 'SEARCH',
            label: '검색'
        }
    ]
}

export default RouteTitleConfig
